import { useState } from "react"
import { FaRegEyeSlash } from "react-icons/fa"
import { RiEyeLine } from "react-icons/ri"
import { BASE_URL } from "../../utils/api"
import { ErrorNotification, SuccessNotification } from "../../utils"
import axios from "axios"
import { useForm } from "react-hook-form"
import { PASSWORDRULES } from "../../utils/Formatter"

const PasswordForm = ({ setActiveStep, activeStep }) => {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch
  } = useForm()

  const password = watch("password") || ""

  const onSubmit = async (values) => {
    setLoading(true)
    try {
      const { data } = await axios.post(`${BASE_URL}auth/password/resetpassword/?email=${localStorage.getItem("email")}`, {
        new_password: values.password,
        confirm_password: values.confirmPassword,
      })
      if (data) {
        SuccessNotification("Password reset successful")
        setActiveStep(activeStep + 1)
      } else {
        ErrorNotification(data.error)
      }
    } catch (error) {
      ErrorNotification(error.response.data.error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="my-6">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        {/* Password */}
        <div>
          <label htmlFor="password" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
            New Password<span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 8,
                  message: "Password must be at least 8 characters"
                }
              })}
              placeholder="Create new password"
              className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 pr-10 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
            />
            <button
              type="button"
              className="absolute right-2 top-3.5 text-gray-400 hover:text-gray-700"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
              {showPassword ? <FaRegEyeSlash /> : <RiEyeLine />}
            </button>
          </div>
          {/* Password rules helper */}
          <div className="mt-3 space-y-1">
            {PASSWORDRULES.map((rule, idx) => {
              const passed = rule.test(password)
              return (
                <div key={idx} className="flex items-center text-sm">
                  <span className={`inline-flex items-center justify-center w-4 h-4 rounded-full mr-2 ${passed ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-400'}`}>{passed ? '✓' : '•'}</span>
                  <span className={passed ? 'text-green-600 font-medium' : 'text-gray-500'}>{rule.label}</span>
                </div>
              )
            })}
          </div>
          {errors.password && (
            <div className="text-red-500 text-xs mt-1">{errors.password.message}</div>
          )}
        </div>

        {/* Confirm Password */}
        <div>
          <label htmlFor="confirmPassword" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
            Confirm Password<span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              {...register("confirmPassword", {
                required: "Confirm password is required",
                validate: value => value === password || "Passwords do not match"
              })}
              placeholder="Confirm your password"
              className="w-full font-normal bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 px-3 pr-10 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
            />
            <button
              type="button"
              className="absolute right-2 top-3.5 text-gray-400 hover:text-gray-700"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              tabIndex={-1}
            >
              {showConfirmPassword ? <FaRegEyeSlash /> : <RiEyeLine />}
            </button>
          </div>
          {errors.confirmPassword && (
            <div className="text-red-500 text-xs mt-1">{errors.confirmPassword.message}</div>
          )}
        </div>

        <div className="mb-4">
          <button
            disabled={isSubmitting || loading}
            type="submit"
            className="bg-yellowcolor w-full capitalize hover:bg-yellowcolor/90 text-black font-normal py-3 px-10 rounded-md"
          >
            <p>{isSubmitting ? "Please wait..." : "Reset Password"} </p>
          </button>
        </div>
      </form>
    </div>
  )
}

export default PasswordForm